import React from "react";

const GOLD = "#ebb51b";
const GRAY = "#9a9ca1";

export const RischioClientiIcon = ({ size = 28, className = "" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Testa cliente */}
      <circle
        cx="25"
        cy="20"
        r="9"
        fill={GOLD}
      />

      {/* Corpo cliente */}
      <path
        d="M9 49C9 38.5 15.8 32 25 32C31.1 32 36.1 34.9 38.8 39.5C34.9 43.3 32.5 48.6 32.5 54H14C11.2 54 9 51.8 9 49Z"
        fill={GOLD}
      />

      {/* Scudo rischio */}
      <path
        d="M43 30L55 34V43C55 51.2 50.1 57.1 43 60C35.9 57.1 31 51.2 31 43V34L43 30Z"
        fill={GRAY}
      />

      {/* Punto esclamativo */}
      <rect
        x="41"
        y="36"
        width="4"
        height="11"
        rx="2"
        fill={GOLD}
      />

      <circle
        cx="43"
        cy="52"
        r="2.2"
        fill={GOLD}
      />
    </svg>
  );
};

export default RischioClientiIcon;